export default __webpack_public_path__ + "static/media/logo_big.baeb359e.svg";